var seedrandom = {exports: {}};

export { seedrandom as __module };
//# sourceMappingURL=seedrandom.js.map
